<div class="confirm-add-rx dcp p-0">
    <div class="header">
        <h2>Confirm Rx ID</h2>
        <div class="divider"></div>
        <strong>The RxID you entered doesn't match with the patient's requested medication. Do you want to proceed ?</strong>
        <div class="rx-id">Rx ID: <span>{{ addedRxNum }}</span></div>
    </div>

    <div class="content">
        <table class="rx-compare-table">
            <thead>
                <tr>
                    <th></th>
                    <th>Brand medication name</th>
                    <th>Generic name</th>
                    <th>Dosage</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td class="row-label">Patient Requested</td>
                    <td>{{ requestedBrand }}</td>
                    <td>{{ requestedGeneric }}</td>
                    <td>{{ requestedDosage }}</td>
                </tr>
                <tr>
                    <td class="row-label">RxID Added</td>
                    <td>{{ krollBrand }}</td>
                    <td>{{ krollGeneric }}</td>
                    <td>{{ krollDosage }}</td>
                </tr>
            </tbody>
        </table>
    </div>

    <div class="actions">
        <button class="btn btn-outline-sil" [disabled]="isLoading" (click)="closeDialog()">Cancel</button>
        <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="add_rx_request_order()">
            {{ isLoading ? 'Confirming...' : 'Confirm' }}
        </button>
    </div>
    <!-- <div class="d-flex justify-content-end align-items-center mt-3">
         <button class="btn btn-outline-sil" [disabled]="isLoading" (click)="closeDialog()">Close</button>
    </div> -->
</div>
